import React, { useState } from "react";
import { Info } from "lucide-react";

/**
 * Small inline info icon that reveals an explainer tooltip on hover/focus/click.
 * Usage: <InfoTip text="What this number means…" testId="sla-tip" />
 */
export default function InfoTip({ text, testId, side = "top", className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <span
      data-testid={testId}
      className={`relative inline-flex ${className}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label="More info"
        className="text-[#606070] hover:text-[#00ff88] transition-colors"
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
      >
        <Info size={13} />
      </button>
      {open && (
        <span
          role="tooltip"
          data-testid={testId ? `${testId}-content` : undefined}
          className={`absolute z-50 w-64 p-3 rounded-lg border border-[#00ff88]/25 bg-[#0a0a14] shadow-xl text-[11px] leading-relaxed text-[#a0a0b0] ${
            side === "top"
              ? "left-1/2 -translate-x-1/2 bottom-[calc(100%+8px)]"
              : "left-1/2 -translate-x-1/2 top-[calc(100%+8px)]"
          }`}
        >
          {text}
        </span>
      )}
    </span>
  );
}
